import React, { useState, useEffect } from "react";
import Logo from './assets/mainlogo.cadcbb3320f1e7b6e53f.png'
import { FaInstagram } from "react-icons/fa6";
import { BiDrink } from "react-icons/bi";
import { WiTime2 } from "react-icons/wi";
import { FaMapSigns, FaRegCopyright } from "react-icons/fa";

function App() {

  const [isOpen, setIsOpen] = useState(false);
  const [impress, setImpress] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://analytics.cordes-cloud.net/script.js';
    script.setAttribute('data-website-id', 'ba96c865-428e-4315-94bf-94afb51fec76');
    document.body.appendChild(script);

    return () => {
      // Cleanup, falls nötig
      document.body.removeChild(script);
    };
  }, []);

  const openMapLink = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    const mapUrl = isIOS
      ? `https://maps.apple.com/place?address=Bahnhofstra%C3%9Fe+81%2C+63165+M%C3%BChlheim+am+Main%2C+Deutschland&coordinate=50.119923%2C8.83559&name=Bahnhofstra%C3%9Fe+81`
      : `https://maps.app.goo.gl/qzauA2Tv5cz8q6oY9`;

    // Navigiere zur Karten-URL
    window.location.href = mapUrl;
  };

  return (
    <div className="relative w-full flex bg-gradient-to-r from-black to-[#1B1919] text-white justify-center items-start py-12">
      <div className="flex flex-col justify-center items-center pb-14 z-10">
        <img src={Logo} className="w-5/6 opacity-100 drop-shadow-[0_0_10px_rgba(255,223,186,0.3)]" alt="logo" />
        <div className="px-12 pt-8">
          <h1 className="text-center text-amber-200/80">Willkommen in unserer Shisha-Oase! 🌙💨</h1>
          <h1 className="text-center pt-4 text-amber-200/80">
            Hier findest du alle Links die du brauchst! Von Angeboten bis zu Events.
          </h1>
          <h1 className="text-center pt-2 text-amber-200/80">Klick dich durch und entspann dich!</h1>
        </div>
        <div className="flex pt-24 gap-10 flex-col">
          <a target="_blank" rel="noreferrer" href="https://www.instagram.com/baccaratloungebar/"
            className="bg-black/50 flex justify-center gap-4 flex-row items-center rounded-lg shadow-lg px-24 py-4 border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)] hover:bg-black/70 transition-all">
            <p className="text-amber-200">Instagram</p>
            <FaInstagram className="text-amber-200 w-6 h-6" />
          </a>
          <a href="https://menu.baccaratlounge.de/" target="_blank" rel="noreferrer"
            className="bg-black/50 cursor-pointer flex justify-center gap-3 flex-row items-center rounded-lg shadow-lg px-24 py-4 border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)] hover:bg-black/70 transition-all">
            <p className="text-amber-200">Speisekarte</p>
            <BiDrink className="text-amber-200 w-6 h-6" />
          </a>
          <div onClick={() => toggleModal()}
            className="bg-black/50 cursor-pointer flex justify-center gap-4 flex-row items-center rounded-lg shadow-lg px-24 py-4 border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)] hover:bg-black/70 transition-all">
            <p className="text-amber-200">Öffnungszeiten</p>
            <WiTime2 className="text-amber-200 w-6 h-6" />
          </div>
          <div onClick={() => openMapLink('50.15143082750605, 8.811279236641047')}
            className="bg-black/50 cursor-pointer flex justify-center gap-4 flex-row items-center rounded-lg shadow-lg px-24 py-4 border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)] hover:bg-black/70 transition-all">
            <p className="text-amber-200">Anfahrt</p>
            <FaMapSigns className="text-amber-200 w-6 h-6" />
          </div>
          <div onClick={() => setImpress(true)}
            className="bg-black/50 cursor-pointer flex justify-center gap-4 flex-row items-center rounded-lg shadow-lg px-24 py-4 border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)] hover:bg-black/70 transition-all">
            <p className="text-amber-200">Impressum</p>
            <FaRegCopyright className="text-amber-200 w-6 h-6" />
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex justify-center items-center z-50">
          <div className="bg-black/50 rounded-lg shadow-lg w-96 p-6 relative border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)]">
            <button
              onClick={toggleModal}
              className="absolute text-white top-2 right-2 hover:text-amber-200"
            >
              ✖
            </button>
            <h2 className="text-xl font-bold mb-4 text-amber-200 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)]">Öffnungszeiten</h2>
            <ul className="text-amber-100/70">
              <li>Montag - Donnerstag: 16:00 - 02:00</li>
              <li>Freitag: 16:00 - 04:00</li>
              <li>Samstag: 15:00 - 04:00</li>
              <li>Sonntag: 15:00 - 02:00</li>
            </ul>
          </div>
        </div>
      )}

      {impress === true ? (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-black/50 max-w-2xl mx-auto rounded-lg shadow-xl border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)] w-full">
            <div className="p-4 border-b border-amber-200/20 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-amber-200 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)]">Impressum</h2>
              <button
                onClick={() => setImpress(false)}
                className="bg-black/50 hover:bg-black/70 text-amber-200 rounded-full p-2 transition-all focus:outline-none focus:ring-2 focus:ring-amber-200/50 border border-amber-200/20"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>

            <div className="overflow-y-auto p-6 max-h-[70vh]">
              <div className="space-y-6 text-left">
                <div className="bg-black/50 p-4 rounded-lg border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)]">
                  <h3 className="text-xl font-semibold text-amber-200 mb-2 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)]">Edmond Brecalia</h3>
                  <p className="text-amber-100/70">
                    Baccarat Lounge<br />
                    Bahnhofstraße 81<br />
                    63165 Mühlheim am Main
                  </p>
                </div>

                <div className="bg-black/50 p-4 rounded-lg border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)]">
                  <h3 className="text-xl font-semibold text-amber-200 mb-2 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)]">Kontakt</h3>
                  <p className="text-amber-100/70">
                    Telefon: <a href="tel:+491632706280" className="text-amber-200 hover:text-amber-300 transition-colors">+49 163 2706 280</a><br />
                    E-Mail: <a href="mailto:brecalia@gmx.de" className="text-amber-200 hover:text-amber-300 transition-colors">brecalia@gmx.de</a>
                  </p>
                </div>

                <div className="bg-black/50 p-4 rounded-lg border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)]">
                  <h3 className="text-xl font-semibold text-amber-200 mb-2 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)]">Umsatzsteuer-ID</h3>
                  <p className="text-amber-100/70">
                    Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                    <span className="font-medium text-amber-200">Folgt in Kürze</span>
                  </p>
                </div>

                <div className="bg-black/50 p-4 rounded-lg border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)]">
                  <h3 className="text-xl font-semibold text-amber-200 mb-2 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)]">Gewerbeanmeldung</h3>
                  <p className="text-amber-100/70">
                    Die Gewerbeerlaubnis nach § 14 GewO wurde am 19.12.2024 von folgender Stelle erteilt: Magistrat der Stadt Mühlheim am Main.
                  </p>
                </div>

                <div className="bg-black/50 p-4 rounded-lg border border-amber-200/20 shadow-[0_0_15px_rgba(255,223,186,0.1)]">
                  <h3 className="text-xl font-semibold text-amber-200 mb-2 drop-shadow-[0_0_5px_rgba(255,223,186,0.3)] break-words hyphens-auto">
                    Verbraucherstreitbeilegung
                  </h3>
                  <p className="text-amber-100/70">
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>

              <div className="mt-6 text-center text-sm">
                <p className="text-amber-100/50">Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-amber-200/70 hover:text-amber-200 transition-colors">eRecht24</a></p>
              </div>
            </div>
          </div>
        </div>
      ) : null}


    </div>


  );
}

export default App;
